//--- Import Export Config here
export const WMS = "https://cargis.vn:8440/geoserver/bacgiang2023/wms/";
export const API_URL_ROOT = "https://api-bacninh.cargis.vn";
export const AdminUrl = "https://admin-bacninh.cargis.vn";
